import React from 'react';

import { observer } from 'mobx-react-lite';
import { HasCalendarType, CalendarEventType } from 'stores/calendar_event_store';
import { CalendarListItemType } from 'stores/calendar_auth_store';
import useStores from 'hooks/useStores';


type CalendarEventContextType = {
    fetchList: (
        workKey: string,
        associated_type: string,
        associated_uuid: string,
        start: string,
        end: string
    ) => Promise<CalendarEventType[]>;

    createEvent: (
        workKey: string,
        associated_type: string,
        associated_uuid: string,
        event: CalendarEventType
    ) => Promise<CalendarEventType | null>;

    updateEvent: (
        workKey: string,
        associated_type: string,
        associated_uuid: string,
        event: CalendarEventType
    ) => Promise<CalendarEventType | null>;

    deleteEvent: (
        workKey: string,
        associated_type: string,
        associated_uuid: string,
        event_id: string,
        calendar_id: string
    ) => Promise<string | null>;

    fetchSyncedCalendars: (
        workKey: string,
        associated_type: string,
        associated_uuid: string,
    ) => Promise<CalendarListItemType[]>;

    fetchHasCalendar: (
        workKey: string,
        associated_type: string,
        associated_uuid: string,
    ) => Promise<HasCalendarType|null>;

    //    getListByAssistant: (calendar_identity: string) => CalendarEventType[];
    //    renderableEvents: RenderableEventType[];
    // Contains all known CalendarEvent items
    items: CalendarEventType[];
}

export const CalendarEventContext = React.createContext<CalendarEventContextType>({
    fetchList: () => { throw "not implemented" },
    //    getListByAssistant: () => [],
    createEvent: async () => ({} as CalendarEventType),
    updateEvent: async () => ({} as CalendarEventType),
    deleteEvent: async () => '',
    fetchSyncedCalendars: () => { throw 'Not Implemented' },
    fetchHasCalendar: () => { throw 'Not Implemented' },

    //    renderableEvents: [],
    items: [] as CalendarEventType[],
});



export const CalendarEventProvider = observer(({ children }: { children: React.ReactNode }) => {
    const { calendarEventStore } = useStores();

    const fetchList = async (
        workKey: string,
        associated_type: string,
        associated_uuid: string,
        start: string,
        end: string) => {

        return calendarEventStore
            .fetchList(workKey,
                associated_type,
                associated_uuid,
                start, end)
            .then((data) => {
                console.log('data going to update', data);
                return data;
                //                updateRenderableEvents();
            })
    };

    // const getListByAssistant = (calendar_identity: string) => {
    //     return calendarEventStore.items
    //         .filter((item) => item.calendar_identity === calendar_identity);
    // };

    const createEvent = async (
        workKey: string,
        associated_type: string,
        associated_uuid: string,
        event: CalendarEventType
    ) => {
        return calendarEventStore.createEvent(workKey, associated_type, associated_uuid, event);
    };

    const updateEvent = async (
        workKey: string,
        associated_type: string,
        associated_uuid: string,
        event: CalendarEventType
    ) => {
        return calendarEventStore.updateEvent(workKey, associated_type, associated_uuid, event);
    };

    const deleteEvent = async (
        workKey: string,
        associated_type: string,
        associated_uuid: string,
        event_id: string,
        calendar_id: string
    ) => {
        return calendarEventStore.deleteEvent(workKey,
            associated_type,
            associated_uuid,
            event_id,
            calendar_id);
    };

    const fetchSyncedCalendars = async (
        workKey: string,
        associated_type: string,
        associated_uuid: string
    ) => {
        return calendarEventStore.fetchSyncedCalendars(
            workKey,
            associated_type,
            associated_uuid);
    };

    const fetchHasCalendar = async (
        workKey: string,
        associated_type: string,
        associated_uuid: string
    ) => {
        return calendarEventStore.fetchHasCalendar(
            workKey,
            associated_type,
            associated_uuid);
    };

    const data = {
        fetchList,

        createEvent,
        updateEvent,
        deleteEvent,
        fetchHasCalendar,
        fetchSyncedCalendars,

        items: calendarEventStore.items,
    };

    return (
        <CalendarEventContext.Provider value={data}>{ children }</CalendarEventContext.Provider>
    );

});
